import { useRef } from "react";
import { useLocation } from "react-router-dom";
import ModalStandard from "src/common/components/Modal/ModalStandard";
import Alert from "src/common/components/Alert/Alert";
import { useAppSelector } from "src/common/state/hooks";
import { getCurrentProject } from "src/features/projects/state/projectsSlice";
import type { GalleryPickerConfig } from "../Gallery";
import { Gallery } from "../Gallery";

const graphNodePathRegex = /^\/courses\/\d{1,256}\/list\/\d{1,256}\/graph\/node\/[^/]+\/\d{1,256}$/;

export const MediaPickerModal = ({ config }: { config: GalleryPickerConfig }) => {
  const { pathname } = useLocation();
  const currentProject = useAppSelector(getCurrentProject);
  const cancelRef = useRef<(() => void) | null>(null);

  const title =
    config.title ?? (graphNodePathRegex.test(pathname) ? currentProject?.name ?? "" : "");

  return (
    <ModalStandard
      id="media-picker"
      modalType="standard"
      controlledMode={{ isOpen: true }}
      clickOnBackgroundClose={false}
      closeOnEscape
      onClose={() => cancelRef.current?.()}
      fullScreen
      isStatic
    >
      <div className="flex w-full">
        <div className="text-center ">
          <Alert />
        </div>
        <div className="grow overflow-y-visible ">
          <Gallery
            picker={{
              ...config,
              title,
              registerCancel: (cancel) => {
                cancelRef.current = cancel;
              },
            }}
          />
        </div>
      </div>
    </ModalStandard>
  );
};
